import { useEffect, useState } from "react";

export function useFetcher(deps = [], fetcher) {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                setIsLoading(true);

                const data = await fetcher();

                setData(data);

            } catch (error) {
                if (error instanceof Error) {
                    setError(error);
                }

            } finally {
                setIsLoading(false);
            }
        })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);

    return {
        data, setData,
        error, setError,
        isLoading, setIsLoading
    };
}
